import React from 'react';
import CheckboxRadio from './CheckboxRadio';
import PropTypes from 'prop-types';

const CheckboxRadioGroup = props => {
    const {
        Component = "div",
        name,
        value,
        onChange,
        children,
        checkboxDepth = 1,
        type,
        ...rest
    } = props;

    const _renderCheckboxes = (children, maxDepth=1, depth=1) => {
        if (depth > maxDepth) {
            return children;
        }

        const checkboxProps = {
            name: name,
            checkedValues: value,
            onChange: onChange,
            inputType: type
        };

        return React.Children.map(children, child => {
            if (!(child && child.$$typeof)) {
                return child;
            }
            else if (child.type === CheckboxRadio) {
                return React.cloneElement(child, {checkboxProps})
            }
            else {
                return React.cloneElement(child, {}, child.props.children ?
                    React.Children.map(child.props.children, c => _renderCheckboxes(c, maxDepth, depth + 1))
                    :
                    null
                )
            }
        });
    };

    return <Component {...rest}>
        {_renderCheckboxes(children, checkboxDepth)}
    </Component>;
};
CheckboxRadioGroup.propTypes = {
    Component: PropTypes.elementType,
    name: PropTypes.string,
    value: PropTypes.any,
    onChange: PropTypes.func,
    checkboxDepth: PropTypes.number,
    type: PropTypes.oneOf(['checkbox', 'radio']).isRequired
};




export default CheckboxRadioGroup;
